import { type ReactNode } from 'react';

import { OrgHubWordmark } from '../orghub-brand';
import * as styles from './index.css';

export const AffineOtherPageLayout = ({
  children,
  topRight,
}: {
  children: ReactNode;
  topRight?: ReactNode;
}) => {
  return (
    <div className={styles.root}>
      {BUILD_CONFIG.isElectron ? (
        <div className={styles.draggableHeader} />
      ) : (
        <div className={styles.topNav}>
          <a href="/" rel="noreferrer" className={styles.affineLogo}>
            <OrgHubWordmark size={18} />
          </a>
          <div className={styles.topNavRight}>{topRight}</div>
        </div>
      )}

      {children}
    </div>
  );
};
